const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Cover My Plate · "File ID" is an internal file number: keep it on the order, hide it from shoppers in the cart.
   (Design uploads used to be handled here too, with a checkout wait. They moved to assets/cmp-uploads.js in
   Nov 2026, which never makes checkout wait.) */
(function () {
  'use strict';
  function hideFileIds(root) {
    var rows = (root || document).querySelectorAll ? (root || document).querySelectorAll('.cxk__props > div, .product-option') : [];
    Array.prototype.forEach.call(rows, function (row) {
      var dt = row.querySelector('dt');
      if (dt && /^\s*File ID:?\s*$/i.test(dt.textContent)) row.style.display = 'none';
    });
  }
  function watchCart() {
    hideFileIds(document);
    if (!window.MutationObserver || !document.body) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { hideFileIds(document); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();
})();
